<template>
  <b-card>
    <!-- <h2 class="text-2xl font-semibold">Session Details</h2> -->
    <div class="pt-4">
      <el-table :data="get_allbookingvol.result" style="width: 100%">
        <el-table-column prop="srno" label="Sr.no" width="180">
          <template slot-scope="row">
            <div v-if="row">{{ row.$index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="servicepn"
          label="Service Provider Name"
          width="180"
        >
          <template v-slot="{ row }">
            <p>
              {{
                `${row.volunteerId.userId.firstname} ${row.volunteerId.userId.lastname}`
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="service" label="Service" width="180">
          <template v-slot="{ row }">
            <p>{{ `${row.volunteerId.service}` }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="Date" width="180">
          <template v-slot="{ row }">
            <p>
              {{
                new Date(row.date).toLocaleDateString("en-IN", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="Phone" width="180">
          <template v-slot="{ row }">
            <p>{{ `${row.volunteerId.userId.mobile} ` }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="Email " width="180">
          <template v-slot="{ row }">
            <p>
              {{
                `${
                  row.volunteerId.userId.email
                    ? row.volunteerId.userId.email
                    : "-"
                } `
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="Time"> </el-table-column>
      </el-table>
    </div>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        @change="handlePageChange"
        v-model="currentPage"
        :total="get_allbookingvol.totalCount"
        :per-page="10"
      ></base-pagination>
      <!-- <b-pagination
        @change="handlePageChange"
        pills
        v-model="currentPage"
        :total-rows="total_row"
        :per-page="perPage"
        size="lg"
        class="ml-auto flex flex-wrap"
      ></b-pagination> -->
    </b-card-footer>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  data() {
    return {
      currentPage: 1,
    };
  },
  components: {
    moment,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },

  methods: {
    getDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    async handlePageChange(num) {
      this.currentPage = num;
      let payload = {
        offset: this.currentPage > 1 ? (this.currentPage - 1) * 10 : 0,
        limit: 10,
        admin: true,
      };
      await this.$store.dispatch("respitecare/get_allbooking", payload);
    },
    async init() {
      await this.$store.dispatch("respitecare/get_allbooking", { admin: true });
      // console.log("get_volunteer_by_admin",this.get_allbookingvol);
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState("respitecare", ["get_allbookingvol"]),
  },
};
</script>
